import { AppShell } from '@/components/layout/AppShell';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { ApiKeysCard } from '../components/ApiKeysCard';
import { OrganizationCard } from '../components/OrganizationCard';
import { ProfileCard } from '../components/ProfileCard';
import { WebhooksCard } from '../components/WebhooksCard';

// /settings — four-tab layout:
//   Profile       → personal info + password (existing ProfileCard)
//   Organization  → org name, branding (existing OrganizationCard)
//   API Keys      → stage + production X-API-KEY / X-API-APP-ID (new)
//   Webhooks      → stage + production webhook URL + delivery logs (new)
//
// Tabs are NOT unmounted when inactive (the `forceMount` prop keeps the
// content in the DOM) so the forms retain their state when switching tabs.
export function SettingsScreen() {
  return (
    <AppShell title="Settings">
      <div className="flex flex-col gap-4 lg:gap-5 text-black-logo">
        <div className="space-y-1.5">
          <h4 className="text-lg leading-[22px] font-medium">Profile &amp; Settings</h4>
          <p className="text-sm leading-[17px] text-gray66">
            Manage your account settings, API credentials, and webhook configuration.
          </p>
        </div>

        <Tabs defaultValue="profile">
          <TabsList className="h-auto bg-transparent p-0 gap-1 border-b border-grayEF rounded-none w-full justify-start">
            <TabsTrigger
              value="profile"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none px-3 pb-2.5 text-sm font-medium text-gray66 hover:text-black-logo transition-colors"
            >
              Profile
            </TabsTrigger>
            <TabsTrigger
              value="organization"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none px-3 pb-2.5 text-sm font-medium text-gray66 hover:text-black-logo transition-colors"
            >
              Organization
            </TabsTrigger>
            <TabsTrigger
              value="api-keys"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none px-3 pb-2.5 text-sm font-medium text-gray66 hover:text-black-logo transition-colors"
            >
              API Keys
            </TabsTrigger>
            <TabsTrigger
              value="webhooks"
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none px-3 pb-2.5 text-sm font-medium text-gray66 hover:text-black-logo transition-colors"
            >
              Webhooks
            </TabsTrigger>
          </TabsList>

          <TabsContent value="profile" className="mt-4">
            <div className="flex max-lg:flex-col items-start gap-4">
              <ProfileCard />
            </div>
          </TabsContent>

          <TabsContent value="organization" className="mt-4">
            <div className="flex max-lg:flex-col items-start gap-4">
              <OrganizationCard />
            </div>
          </TabsContent>

          <TabsContent value="api-keys" className="mt-4">
            <ApiKeysCard />
          </TabsContent>

          <TabsContent value="webhooks" className="mt-4">
            <WebhooksCard />
          </TabsContent>
        </Tabs>
      </div>
    </AppShell>
  );
}
